import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobDomainService } from '../domain/services/job/job.domain.service';
import { MaterialModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from 'ng2-translate';

import { CreateProjectComponent } from './components/create-project/create-project.component';
import { DeleteProjectComponent } from './components/delete-project/delete-project.component';
import { ProjectOverviewComponent } from './project-overview.component';

import { ProjectOverviewService } from './services/project-overview.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    TranslateModule.forRoot()
  ],
  exports: [
    ProjectOverviewComponent
  ],
  providers: [
    ProjectOverviewService,
    JobDomainService],
  declarations: [
    ProjectOverviewComponent,
    CreateProjectComponent,
    DeleteProjectComponent
  ]
})
export class ProjectOverviewModule { }



// WEBPACK FOOTER //
// ./src/app/modules/project-overview/project-overview.module.ts